import Cookies from 'js-cookie';
import { monthsOld } from './utils';

export const playRecursive = (_ind = 0, _arr, _snds) => {

    let _audio = "";

    switch (_arr[_ind]) {
        case "scanned":
            _audio = _snds.scanned;
            break;
        case "short":
            _audio = _snds.short;
            break;
        case "even":
            _audio = _snds.even;
            break;
        case "over":
            _audio = _snds.over;
            break;
        case "not_found":
            _audio = _snds.error;
            break;
        case "old":
            _audio = _snds.old;
            break;
    }

    if (!_audio) {
        return;
    }

    _audio.play();
    _audio.onended = () => {
        if (_ind + 1 < _arr.length) {
            playRecursive(_ind + 1, _arr, _snds);
        }
    };
};


export const playRecSound = (_count, _onhand, _old = false, _found = true, _snds, _play_scanned = true) => {

    // Setup sounds object
    let sounds = { scanned: false, short: false, over: false, even: false, error: false, months: 0 }

    // Overwrite with cookies
    if (Cookies.get("bm_sounds")) {
        sounds = JSON.parse(Cookies.get("bm_sounds"))
    }

    // Create sounds array
    let _sounds = [];

    // Scanned
    if (sounds.scanned && _play_scanned) {
        _sounds.push("scanned")
    }

    // Error
    if (!_found) {
        if (sounds.error) {
            _sounds.push("not_found");
            playRecursive(0, _sounds, _snds);
        }
        return;
    }

    // Under
    if ((_count < _onhand) && (sounds.short)) {
        _sounds.push("short");
    }

    // Even
    if ((_count === _onhand) && (sounds.even)) {
        _sounds.push("even");
    }

    // Over
    if ((_count > _onhand) && (sounds.over)) {
        _sounds.push("over");
    }

    // Old
    if (_old && (sounds.months)) {
        let _months_old = monthsOld(_old);
        let _oldint = parseInt(sounds.months)
        if (_oldint > 0) {
            if (_months_old >= _oldint) {
                _sounds.push("old");
            }
        }
    }

    playRecursive(0, _sounds, _snds);
}

